import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const GradeBookLazy = React.lazy(
	() => import(/* webpackChunkName : 'GradeBook' */ './components')
);

export default (store) => {
	return [
		{
			path: 'home/gradebook-dashboard',
			element: <AsyncLoading component={<GradeBookLazy />} />,
		},
	];
};
